import Layout from '@/components/Layout';
import { BillingModalHost } from '@/components/subscription/billing-modal/BillingModalHost';
import { usePaywall } from '@/hooks/use-paywall';
import { Heading, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** The dashboard frame is available while the canonical billing decision denies business access. */
export function BillingApprovalDashboard() {
  const { t } = useTranslation();
  const { paywall } = usePaywall();
  const navigate = useNavigate();
  return (
    <Layout billingLimited>
      <Stack p={{ base: 5, md: 8 }}>
        <Heading size="xl">{t('navigation.dashboard')}</Heading>
      </Stack>
      {paywall === 'plans' && <BillingModalHost onClose={() => navigate('/settings/billing')} />}
    </Layout>
  );
}
